import { TradingExecutionRoute } from '@ebalance/proto/bfftypes/v1/trading_execution_route_pb'

/**
 * 48 点データ画面の取引種別 (AC-S4D-001)。
 *
 * 常時BU は独立カテゴリに分離せず相対取引カテゴリ内に含めるため、行がどちらなのかは
 * 約定経路から導出して表示する (判断 2026-07-31 / #4335)。導出規則の SoT は
 * mock-app/docs/domain-knowledge.md「常時BU 経路 → 常時BU / それ以外 → 相対取引」。
 *
 * 需給ギャップ・計画提出のスタック集計は従来どおり常時BU として集計するため、
 * backend の SupplyCategory enum からは 常時BU を消していない (表示上の統合のみ)。
 */
export type Supply48TradeType = 'backupRegular' | 'bilateral'

/** 約定経路から取引種別を導出する */
export function tradeTypeOf(route: TradingExecutionRoute): Supply48TradeType {
  return route === TradingExecutionRoute.BACKUP_REGULAR
    ? 'backupRegular'
    : 'bilateral'
}

/** 取引種別 → i18n キー */
export function tradeTypeLabelKey(tradeType: Supply48TradeType): string {
  return tradeType === 'backupRegular'
    ? 'page:supply48Data.filter.categoryBackupRegular'
    : 'page:supply48Data.filter.categoryBilateral'
}
